import Cookies from 'js-cookie';
import superjson from 'superjson';
import { httpLink, loggerLink } from '@trpc/client';
import { createTRPCMsw } from 'msw-trpc';
import { createTRPCReact } from '@trpc/react-query';

import { AppRouter } from '@/server/routers/_app';
import {
  ACCESS_TOKEN_COOKIE_NAME,
  REGISTRATION_PRE_MFA_TOKEN_COOKIE_NAME,
  REGISTRATION_MFA_TOKEN_COOKIE_NAME,
  FORGOT_FLOW_MFA_TOKEN_COOKIE_NAME,
  FORGOT_FLOW_PRE_MFA_TOKEN_COOKIE_NAME
} from '@/utils/cookies';

export const trpcMsw = createTRPCMsw<AppRouter>({
  transformer: {
    input: superjson,
    output: superjson
  }
});

export const trpc = createTRPCReact<AppRouter>();

export const trpcConfig = {
  transformer: superjson,
  links: [
    loggerLink({
      enabled: (opts) =>
        (process.env.NEXT_PUBLIC_APP_ENV !== 'prod' && typeof window !== 'undefined') ||
        (opts.direction === 'down' && opts.result instanceof Error)
    }),
    httpLink({
      url: '/api/trpc',
      headers: () => {
        // If the user has an `access-token` cookie, send it as a bearer
        // token in every tRPC request
        const accessToken = Cookies.get(ACCESS_TOKEN_COOKIE_NAME);
        const registrationPreMfaToken = Cookies.get(REGISTRATION_PRE_MFA_TOKEN_COOKIE_NAME);
        const registrationMfaToken = Cookies.get(REGISTRATION_MFA_TOKEN_COOKIE_NAME);
        const forgotFlowPreMfaToken = Cookies.get(FORGOT_FLOW_PRE_MFA_TOKEN_COOKIE_NAME);
        const forgotFlowMfaToken = Cookies.get(FORGOT_FLOW_MFA_TOKEN_COOKIE_NAME);

        const tokens = [
          registrationPreMfaToken,
          registrationMfaToken,
          accessToken,
          forgotFlowPreMfaToken,
          forgotFlowMfaToken
        ];

        // eslint-disable-next-line no-restricted-syntax
        for (const token of tokens) {
          if (token) {
            return { Authorization: `Bearer ${token}` };
          }
        }

        return {};
      }
    })
  ]
};

export const createTRPCClient = () => trpc.createClient(trpcConfig);
